<template>
  <div id="app">
    <router-view></router-view>
    <myChat :otherid="$store.state.otherid"></myChat>
  </div>
</template>

<script>
  import myChat from '@/modules/myChat'
  export default {
    name: 'app',
    data (){
      return{
        
      }
    },
    components: { myChat },
    watch: {
      '$route'(to, from) {
        var _this = this;
        _this.$store.state.chatFlag = false;
      }
    },
    mounted:function(){
      var _this = this;
      _this.ready();
    },
    methods:{
      ready: function () {
        var _this = this;
        _this.$store.state.token = $.cookie('LYPT_token');
        _this.$store.state.userInfo = {
          id: $.cookie('LYPT_id'),
          messageNum: $.cookie('LYPT_messageNum'),
          avatar: $.cookie('LYPT_avatar'),
          nickname: $.cookie('LYPT_nickname'),
          isServicer: $.cookie('LYPT_isServicer')
        };
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue